import React from "react";
import { Link } from "react-router-dom";

export default function SidebarItem({ label, to, active }) {
	return (
		<li className="mb-2">
			<Link
				to={to}
				className={`w-full block text-left px-3 py-2 rounded-lg font-medium transition
        ${active ? "bg-gray-100 text-black" : "text-gray-600 hover:bg-gray-50"}
        `}
			>
				{label}
			</Link>
		</li>
	);
}
